import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import "material-design-icons-iconfont/dist/material-design-icons.css";

Vue.use(Vuetify);
// Check if in development OR if in production with port 3074
const isTestEnv = process.env.NODE_ENV !== 'production' ||
  (process.env.NODE_ENV === 'production' &&
    process.env.VUE_APP_API_URL_PRODUCTION &&
    process.env.VUE_APP_API_URL_PRODUCTION.includes("3074"));

const primaryColor = isTestEnv ? '#00897B' : '#3F51B5';
export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: primaryColor,
        primarys: "#42A5F5",
        secondary: "#F57F17",
        accent: "#7986CB",
        error: "#E53935",
        info: "#2196F3",
        success: "#00897B",
        warning: "#FFC107",
        colorbarra: "#008080",
        cyanText: "#1976D2",
      },
    },
  },

  icons: {
    iconfont: "md",
  },
});
